import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { CONFIGURE_RESOURCE_CONFIGURE_PAGE } from './utils/configureResourceIds';

import { ConfigureModules } from './components/ConfigureModules';
import { useConfigurePage } from './hooks/useConfigurePage';

const CONFIGURE_BREADCRUMBS = [{ label: 'Configure', isActive: true }];

const ConfigurePage = () => {
  const { hasSelectedDealer } = useConfigurePage();

  return (
    <>
      <Helmet>
        <title>Configure the dealership</title>
        <meta
          name="description"
          content="Configure dealership nurturing content, calendar, segments, and messaging preferences"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasSelectedDealer}
        breadcrumbsList={CONFIGURE_BREADCRUMBS}
        pageTitle="Configure the dealership"
        contentVariant="centered"
      >
        <ConfigureModules />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  ConfigurePage,
  CONFIGURE_RESOURCE_CONFIGURE_PAGE,
);
